module.exports = __webpack_public_path__ + "assets/icon-insights-component.7f01c043.svg";